import Vue from "vue";

const CLIENT_VERSION = "legacy";

// Store user type to set it when cookies are accepted
let pendingUserType = null;

const personalExperienceCookieAccepted = () => {
  const currentSession = Vue.$cookies.get("stb_cookie_consent");
  return !!(currentSession && currentSession.personal === true);
};

// Set pending user type if cookies aren't accepted yet
const setPendingUserType = () => {
  if (pendingUserType && personalExperienceCookieAccepted()) {
    // eslint-disable-next-line no-undef
    gtag("set", {
      user_properties: {
        user_type: pendingUserType,
        client_version: CLIENT_VERSION,
      },
    });
    pendingUserType = null; // Clear after setting
  }
};

export const trackGoogleEvent = (
  eventName,
  eventCategory,
  eventLabel,
  eventPayload,
) => {
  // Set pending user type if cookies are now accepted
  setPendingUserType();

  if (!personalExperienceCookieAccepted()) return;

  const eventData = {
    event_category: eventCategory,
    event_label: eventLabel,
  };

  if (eventPayload) eventData.data = eventPayload;

  // eslint-disable-next-line no-undef
  gtag("event", eventName, eventData);
};

export const trackFacebookEvent = (eventName, eventPayload = {}) => {
  if (!personalExperienceCookieAccepted()) return;

  // eslint-disable-next-line no-undef
  fbq("trackCustom", eventName, eventPayload);
};

export const updateGAPagePath = (pagePath) => {
  if (!personalExperienceCookieAccepted()) return;

  // eslint-disable-next-line no-undef
  gtag("config", "UA-22748334-1", { page_path: pagePath });
};

export const setGAUserType = (userType) => {
  if (personalExperienceCookieAccepted()) {
    // eslint-disable-next-line no-undef
    gtag("set", {
      user_properties: { user_type: userType, client_version: CLIENT_VERSION },
    });
  } else {
    // Store user type to set it when cookies are accepted
    pendingUserType = userType;
  }
};
